module.exports = __webpack_public_path__ + "img/status-ok.3f3a94c9.png";